import { NodeContext } from "../../../poly/NodeContext";
import { SceneJsonImporter } from "../../../io/json/import/Scene";
import { JsonExportDispatcher } from "../../../io/json/export/Dispatcher";
import { createPolySopNode } from "../../sop/utils/poly/createPolySopNode";
import { ParamTemplate } from "../params/ParamsConfig";
import { Poly } from "../../../Poly";
import { ArrayUtils } from "../../../../core/ArrayUtils";
import { JsonImportDispatcher } from "../../../io/json/import/Dispatcher";
import { createPolyObjNode } from "../../obj/utils/poly/createPolyObjNode";
import { createPolyAnimNode } from "../../anim/utils/poly/createPolyAnimNode";
import { createPolyGlNode } from "../../gl/utils/poly/createPolyGlNode";
const _PolyNodeController = class {
  constructor(node, _definition) {
    this.node = node;
    this._definition = _definition;
  }
  initializeNode() {
    this._initInputs();
    this.node.lifecycle.onAfterCreated(() => {
      this.createChildNodesFromDefinition();
    });
  }
  _initInputs() {
    const inputsData = this._definition.inputs;
    if (!inputsData) {
      return;
    }
    const simpleData = inputsData.simple;
    if (simpleData) {
      this.node.io.inputs.setCount(simpleData.min, simpleData.max);
    }
  }
  static setupParamsConfig(paramsConfig, data) {
    if (!data.params) {
      return;
    }
    for (let paramData of data.params) {
      const paramName = paramData.name;
      const paramType = paramData.type;
      const initValue = paramData.initValue;
      const options = paramData.options;
      paramsConfig[paramName] = new ParamTemplate(paramType, initValue, options);
    }
  }
  createChildNodesFromDefinition() {
    const childrenData = this._definition.nodes;
    if (!childrenData) {
      return;
    }
    const currentSceneLoadedState = this.node.scene().loadingController.loaded();
    if (currentSceneLoadedState) {
      this.node.scene().loadingController.markAsLoading();
    }
    const sceneImporter = new SceneJsonImporter({});
    const dispatcher = new JsonImportDispatcher();
    const nodeImporter = dispatcher.dispatchNonPolyNode(this.node);
    nodeImporter.create_nodes(sceneImporter, childrenData);
    const ui_data = this._definition.ui;
    if (ui_data) {
      nodeImporter.processNodesUiData(sceneImporter, ui_data);
    }
    if (currentSceneLoadedState) {
      this.node.scene().loadingController.markAsLoaded();
    }
  }
  static inputsData(node) {
    if (node.io.inputs.hasNamedInputs()) {
      const inputs = node.io.inputs;
      const connectionPoints = ArrayUtils.compact(inputs.namedInputConnectionPoints());
      return {
        typed: {
          types: connectionPoints.map((cp) => {
            return {
              name: cp.name(),
              type: cp.type()
            };
          })
        }
      };
    } else {
      return {
        simple: {
          min: node.io.inputs.minCount(),
          max: node.io.inputs.maxInputsCount()
        }
      };
    }
  }
  static polyNodeData(node, inputsData) {
    const dispatcher = new JsonExportDispatcher();
    const rootExporter = dispatcher.dispatchNode(node);
    const nodesData = rootExporter.data({ showPolyNodesData: true });
    const uiData = rootExporter.uiData({ showPolyNodesData: true });
    const nodeInputsData = inputsData || this.inputsData(node);
    const data = {
      nodeContext: node.context(),
      inputs: nodeInputsData,
      params: node.params.non_spare.filter((p) => p.parentParam() == null).map((param) => {
        const paramData = {
          name: param.name(),
          type: param.type(),
          initValue: param.defaultValueSerialized(),
          rawInput: param.rawInputSerialized(),
          options: param.options.current()
        };
        return paramData;
      }),
      nodes: nodesData.nodes,
      ui: uiData.nodes
    };
    return data;
  }
  static _createNodeClass(nodeContext, nodeType, data) {
    switch (nodeContext) {
      case NodeContext.ANIM:
        return createPolyAnimNode(nodeType, data, _PolyNodeController);
      case NodeContext.GL:
        return createPolyGlNode(nodeType, data, _PolyNodeController);
      case NodeContext.OBJ:
        return createPolyObjNode(nodeType, data, _PolyNodeController);
      case NodeContext.SOP:
        return createPolySopNode(nodeType, data, _PolyNodeController);
    }
  }
  static createNodeClassAndRegister(dataRegister) {
    const { context, type, data } = dataRegister;
    const nodeClass = this._createNodeClass(context, type, data);
    if (nodeClass) {
      let registerMapForContext = this._definitionRegister.get(context);
      if (!registerMapForContext) {
        registerMapForContext = /* @__PURE__ */ new Map();
        this._definitionRegister.set(context, registerMapForContext);
      }
      registerMapForContext.set(type, data);
      Poly.registerNode(nodeClass, "polyNodes", { polyNode: true });
    }
  }
  static definition(context, type) {
    var _a;
    return (_a = this._definitionRegister.get(context)) == null ? void 0 : _a.get(type);
  }
};
export let PolyNodeController = _PolyNodeController;
PolyNodeController._definitionRegister = /* @__PURE__ */ new Map();
